<app-topbar></app-topbar>
<p-toast></p-toast>
<div class="spinner-overlay" *ngIf="loading">
  <p-progressSpinner/>
</div>

<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="grid justify-content-center">
        <div class="col-12 md:col-10">
          <!-- Seção de saudação e campo de busca -->
          <div class="flex align-content-center flex-wrap">
            <p class="mb-2 text-lg" style="color: rgb(9, 64, 103);">Como posso te ajudar hoje?</p>
            <div class="flex align-items-center gap-2 w-12">
              <div class="input-container">
                <input
                  type="text"
                  placeholder="Encontre o prompt ideal ..."
                  class="p-inputtext-lg w-full input-with-button input-border"
                  pInputText
                  [(ngModel)]="valorBusca"
                  (keyup.enter)="buscarPrompts()"
                />
                <button title="Pesquisar" class="btn-search" (click)="buscarPrompts()">
                  <i class="pi pi-search"></i>
                </button>
              </div>
            </div>

            <div class="mt-2">
              <a href="/cadastro-prompt" class="text-blue-500 text-base"
                >Ou Cadastre seu clicando aqui!</a
              >
            </div>
          </div>
        </div>

        <!-- Botão Filtros + Ordenação + Visualização grid/lista -->
        <div class="col-12 md:col-10 mt-2 md:justify-content-between flex flex-wrap gap-2 align-items-center">
          <!--<div>
            <button [disabled]="true" pButton title="mostrar/ocultar filtros" pRipple [icon]="!isFiltroAberto ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" class="bt-tema" (click)="toggleFiltros()" label="Filtros"></button>
          </div>-->
          <div class="flex justify-content-center align-items-center gap-2">
            <p-dropdown
              [options]="opcoesOrdenacao"
              [(ngModel)]="tipoBusca"
              placeholder="Filtrar por"
              (onChange)="onOrdenacaoChange()"
              styleClass=""
            ></p-dropdown>
            <ul class="p-2 m-0 list-none flex overflow-x-auto select-none">
              <li>
                <a
                  (click)="setActiveSecondaryButton(1)"
                  class="p-ripple p-element cursor-pointer px-2 py-2 mr-2 flex align-items-center hover:surface-100 border-round transition-colors transition-duration-150"
                >
                  <i
                    class="pi pi-th-large mr-2"
                    [style.color]="activeSecondaryButton === 1 ? '#007ad9' : '#b2bec3'"
                  ></i>
                </a>
              </li>
              <li>
                <a
                  (click)="setActiveSecondaryButton(0)"
                  class="p-ripple p-element cursor-pointer px-2 py-2 flex align-items-center hover:surface-100 border-round transition-colors transition-duration-150"
                >
                  <i
                    class="pi pi-list-check mr-2"
                    [style.color]="activeSecondaryButton === 0 ? '#007ad9' : '#b2bec3'"
                  ></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Facelets: exibidos somente ao clicar em Filtros, organizados por seção -->
        <div *ngIf="isFiltroAberto" class="col-12 md:col-10 mt-2 filtro-open">
          <div *ngIf="facetCategorias.length > 0" class="flex flex-column gap-3 py-2">
            <div *ngFor="let group of facetCategorias" class="flex flex-column gap-1">
              <span class="facet-section-label text-sm font-medium text-700">{{ group.section }}</span>
              <div class="flex flex-wrap gap-2 align-items-center">
                <button
                  *ngFor="let facet of group.items"
                  type="button"
                  class="facet-pill"
                  [class.facet-pill-active]="categoriasFacetSelecionadas.includes(facet.value)"
                  (click)="aplicarFiltroFacet(facet.value)">
                  {{ facet.value }} ({{ facet.count }})
                </button>
              </div>
            </div>
          </div>
          <p *ngIf="facetCategorias.length === 0" class="text-500 text-sm m-0 py-2">Nenhum filtro disponível para esta busca.</p>
        </div>

        <div class="col-12 md:col-10 mt-2">
          <div class="flex align-items-center justify-content-start gap-2">
            <span class="text-lg">Resultados encontrados: </span>
            <p-badge class="text-lg mb-0" [value]="totalResultados" severity="info"></p-badge>
          </div>
        </div>
        <!--*ngIf="((filtrados | async) ?? []).length == 0 && categorias.length == 0"-->
        <div class="col-12 md:col-10 mt-2">
          <!-- Lista ou Grid de prompts -->
          <div [ngClass]="{ grid: isGridView, list: !isGridView }">
            <div
              *ngFor="let prompt of displayedPrompts"
              [ngClass]="isGridView ? 'col-12 md:col-6 xl:col-4' : 'col-12'"
              class="mb-2">

              <div
                [ngClass]="{
                  'shadow-1 border-round-lg p-4 bg-CNJ': isGridView,
                  'bg-white p-3': !isGridView
                }">
                <!-- Conteúdo do Card -->
                <div
                  [ngClass]="{
                    'border-bottom-1 surface-border pb-4': isGridView,
                    'pb-1 mb-2': !isGridView
                  }"
                >
                  <div class="flex flex-column align-items-start">
                    <span
                      class="text-lg text-900 font-medium mb-1 truncate-text"
                      [innerHTML]="highlightText(prompt.title)"
                      (click)="!isGridView && abrirTelaPrompt(prompt.id)"
                      [style.cursor]="!isGridView ? 'pointer' : 'default'"
                    ></span>

                    <div class="flex align-items-center gap-2 mb-3 mt-2">
                      <img
                          *ngIf="prompt.usuarioAvatar$ | async as avatar"
                          [src]="avatar"
                          alt="Avatar do Usuário"
                          class="border-circle"
                          style="width: 40px; height: 40px; object-fit: cover"
                        />
                     <p class="text-xs text-slate-700 mb-0"> {{ prompt.nomeUsuario$ | async }}</p>
                   </div>
                    <p
                      [ngClass]="{ 'm-0': !isGridView }"
                      class="truncate-text text-sm"
                      [innerHTML]="highlightText(prompt.description)"
                      [attr.title]="prompt.description"
                    ></p>
                  </div>

                  <div
                    class="flex pt-3 pb-1 gap-4"
                    (click)="abrirTelaPrompt(prompt.id)"
                  >
                    <p-rating
                      [ngModel]="prompt.mediaAvaliacao"
                      readonly="true"
                      stars="5"
                      [cancel]="false"
                    ></p-rating>

                    <a class="text-blue-500 text-sm cursor-pointer">
                      {{ prompt.totalAvaliacoes }} Avaliações
                    </a>
                  </div>
                  <div *ngIf="prompt.tags?.length" class="flex pt-1 pb-0 gap-1 flex-wrap">
                    <span
                      *ngFor="let tag of prompt.tags | slice:0:2"
                      class="text-xs text-500 px-1 py-0"
                      [title]="sanitizeTag(tag)">
                      {{ sanitizeTag(tag) }}
                    </span>
                  </div>
                </div>

                <!-- Botões -->
                <div class="flex justify-content-end pt-2">
                  <button
                    class="mr-2 bt-tema"
                    pButton
                    pRipple
                    type="button"
                    (click)="abrirTelaPrompt(prompt.id)"
                  >Conheça o prompt</button>
                  <button
                    pButton
                    pRipple
                    type="button"
                    class="bt-tema-2"
                   (click)="copiarTexto(prompt)"
                  >Copiar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-content-between mt-2">
            <p-button
              label="Página Anterior"
              (click)="irPaginaAnterior()"
              [disabled]="paginaAtual === 0"
            ></p-button>
            <p-button
              label="Próxima Página"
              (click)="irProximaPagina()"
              [disabled]="paginaAtual === totalPages - 1"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
